import { gql } from '@apollo/client';

export const GET_FRAMEWORK_ANSWER = gql`
  query GetFrameworkAnswer($input: GetFrameworkAnswerInput!) {
    frameworkAnswer: getFrameworkAnswer(input: $input) {
      id
      answer
      files {
        id
        url
      }
      question {
        id
      }
    }
  }
`;
